import { RESET_INDICATIONS } from './actionTypes';

const resetIndications = () => ({ type: RESET_INDICATIONS });

export default resetIndications;
